import { Text, Flex } from '@fluentui/react-northstar';

// Services
import { useTranslation } from 'SERVICES/i18n';

// Components
import AkouoSupport from 'COMPONENTS/AkouoSupport';
import TabFooter from 'COMPONENTS/tabFooter/TabFooter';
import FullScreenLoader from 'COMPONENTS/FullScreenLoader';
import MicrosoftSignInButton from 'COMPONENTS/MicrosoftSignInButton';

// Features
import useTab from 'FEATURES/tab/hooks/useTabs';
import PreMeeting from 'FEATURES/tab/preMeeting/PreMeeting';
import InMeeting from 'FEATURES/tab/inMeeting/InMeeting';

// Constants
import { LANGUAGE_PREFIX, TEAMS_LANGUAGE_RESOURCE } from 'CONSTANTS/teamsConstants';

// Style
import './Tab.scss';
import { FRAME_CONTEXT } from 'CONSTANTS/enum';

const Tab = () => {
  const { frameContext, loading, isAuthorized, authenticate } = useTab();
  const { t } = useTranslation(TEAMS_LANGUAGE_RESOURCE, LANGUAGE_PREFIX.TAB);

  if (loading) return <FullScreenLoader label={t('LOADING_TEAMS_ACCOUNT')} />;

  if (!isAuthorized && frameContext) {
    return (
      <Flex fill hAlign="center" vAlign="center" column>
        <Text content={t('AUTH_ERROR_MSG')} align="center" />
        <AkouoSupport size="small" align="center" className="pt-1" />
        <MicrosoftSignInButton onClick={authenticate} />
      </Flex>
    );
  }

  const render = () => {
    if (frameContext === FRAME_CONTEXT.preMeeting) return <PreMeeting />;
    if (frameContext === FRAME_CONTEXT.sidePanel) return <InMeeting />;

    return <Text align="center" className="pt-4" content={t('UNSUPPORTED_FRAME_MESSAGE')} />;
  };

  return (
    <Flex fill column>
      <div className="meeting-content">{render()}</div>
      <TabFooter className="footer-style" />
    </Flex>
  );
};

export default Tab;
